import React from 'react';
import ReactDOM from 'react-dom/client';
import type { ChainIndexProps } from '~/types/Chain';
import { ChainIndex } from '~/pages/Chain/Index/ChainIndex';

import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: ChainIndexProps;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <ChainIndex {...data} />
  </React.StrictMode>
);
